<template>
  <v-stepper v-model="step">
    <v-stepper-header>
      <v-stepper-step :complete="step > 1" step="1">Выбор тарифа</v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step :complete="step > 2" step="2">Реквизиты</v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step step="3">Завершение</v-stepper-step>
    </v-stepper-header>

    <v-stepper-items>
      <v-stepper-content step="1">
        <SelectTariff @tariffSelect="step = 2" />

        <!-- <v-btn color="primary" @click="step = 2" :disabled='tariffSelect'> Продолжить </v-btn> -->
      </v-stepper-content>

      <v-stepper-content step="2">
        <!-- <v-card class="mb-12" color="grey lighten-1" height="200px"></v-card>
         -->
        <PaymentTypeSelecter v-model="selectedPaymentType" />
        <PaymentCard v-if="step == 2 && selectedPaymentType === 'card'" />
        <PaymentBank v-if="step == 2 && selectedPaymentType === 'bank'" @setValid="setValid($event)" />
        <v-btn color="primary" @click="step = 1"> Назад </v-btn>
        <v-btn color="primary" @click="step = 3" :disabled="!valid">
          Продолжить
        </v-btn>
      </v-stepper-content>

      <v-stepper-content step="3">
        <PaymentBillDownload />
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>
<script>
import SelectTariff from "./components/SelectTariffs.vue";
import PaymentTypeSelecter from "./components/PaymentTypeSelect.vue";
import PaymentCard from "./components/PaymentCard.vue";
import PaymentBank from "./components/PaymentBank.vue";
import PaymentBillDownload from "./components/PaymentBillDownload.vue";
export default {
  components: {
    SelectTariff,
    PaymentTypeSelecter,
    PaymentCard,
    PaymentBank,
    PaymentBillDownload,
  },
  data: () => ({
    step: 1,
    valid: false,
  }),
  methods: {
    setValid(ev) {
      this.step = ev.step;
      this.valid = ev.valid;
    },
    // checkNeedData() {
    //   const firmData = this.$store.getters.getOrganisationAgent
    //   if(this.showKPP){
    //     return firmData.inn &&
    //     firmData.kpp &&
    //     firmData.orgShortName &&
    //     firmData.jurrAddr ? false : true
    //   }else{
    //     return firmData.inn &&
    //     firmData.orgShortName &&
    //     firmData.jurrAddr ? false : true
    //   }
    // },
    // setShowKPP(val){
    //   this.showKPP = val
    // }
  },
  computed: {
    tariffSelect() {
      return this.$store.getters.selectedTariff === null ? true : false;
    },
    selectedPaymentType: {
      get() {
        return this.$store.getters.selectedPaymentType;
      },
      set(val) {
        this.$store.commit("setPaymentCardParam", {
          name: "card",
          value: null,
        });
        this.$store.commit("setPaymentCardParam", {
          name: "mouth",
          value: null,
        });
        this.$store.commit("setPaymentCardParam", {
          name: "year",
          value: null,
        });
        this.$store.commit("setPaymentCardParam", { name: "cvv", value: null });
        this.$store.commit("setSelectedPaymentType", val);
      },
    },
  },
};
</script>
